import React, { ChangeEvent, useCallback, useState } from 'react';

import { Scrollbar } from '@/components/Scrollbar';
import {
	AsaphDialog,
	AsaphDialogHeader,
	AsaphDialogHeaderButton,
} from '@/components/shared/Dialog';
import { SearchInput } from '@/components/shared/Inputs';
import { PANEL_TRANSITION_TIMEOUT } from '@/config/constants';
import { classNames } from '@/helpers/classNames';
import { CircularProgress } from '@material-ui/core';

import {
	SearchAndFilter,
	SearchAndFilterProps,
} from '../shared/SearchAndFilter';
import styles from './SonglistPanelLayout.module.scss';

export interface SonglistPanelLayoutProps {
	open: boolean;
	handleClose: () => void;
	handleFilterChange: SearchAndFilterProps['onChange'];
	title?: string;
	actionButton?: JSX.Element;
	listClassName?: string;
	clearFilters?: number;
	excludeFilters?: SearchAndFilterProps['excludeFilters'];
	isLoading?: boolean;
	hideViewBy?: boolean;
}

export const SonglistPanelLayout: React.FC<SonglistPanelLayoutProps> = ({
	open,
	handleClose,
	handleFilterChange,
	children,
	title = '',
	actionButton,
	listClassName,
	clearFilters,
	excludeFilters,
	isLoading,
	hideViewBy,
}) => {
	return (
		<AsaphDialog
			open={open}
			onClose={handleClose}
			className={styles['songlist-panel-layout']}
		>
			<div className={styles['toolbar']}>
				<AsaphDialogHeader
					leadingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: (
							<AsaphDialogHeaderButton
								type="text"
								label="Cancel"
								handlePress={handleClose}
							/>
						),
					}}
					title={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						label: title,
					}}
					trailingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: null,
					}}
				/>
			</div>
			<div className={styles['search']}>
				<SearchAndFilter
					onChange={handleFilterChange}
					clearFilters={clearFilters}
					placeholder="Search song title, artist, or CCLI #"
					excludeFilters={excludeFilters}
					hideViewBy={hideViewBy}
				/>
			</div>
			<section className={styles['content']}>
				<div className={styles['content-container']}>
					<div
						className={classNames([styles['list'], listClassName])}
					>
						{children}
					</div>
					{isLoading && (
						<div className={styles['loading']}>
							<CircularProgress />
						</div>
					)}
				</div>
				{actionButton && (
					<div className={styles['action']}>{actionButton}</div>
				)}
			</section>
		</AsaphDialog>
	);
};
